/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2025 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { useEffect, useState } from "react";

const CHECK_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes

const useVersionCheck = () => {
  const [serverVersion, setServerVersion] = useState("");
  const currentVersion = import.meta.env.VITE_APP_ADVAPACS_VERSION || ""; // Build-time version

  useEffect(() => {
    const url = window.location.pathname.startsWith("/Worklist")
      ? "/Worklist/version.txt"
      : "/version.txt";
    const checkVersion = () => {
      fetch(url)
        .then((res) => res.text()) // Read as plain text
        .then((server) => setServerVersion(server.trim()))
        .catch(() => setServerVersion(""));
    };

    checkVersion(); // Run immediately on mount
    const interval = setInterval(checkVersion, CHECK_INTERVAL); // Periodic check

    return () => clearInterval(interval);
  }, []);

  return (
    currentVersion !== "" &&
    serverVersion !== "" &&
    currentVersion !== serverVersion
  ); // True if update is needed
};

export default useVersionCheck;
